/* istanbul ignore file */
import { TextField, useFieldHelper } from 'framework/ui/field';

const VacancyPublicationOptionField = (props: any) => {
  const { getValue } = useFieldHelper(props);
  const data: any = getValue();

  return data.type === 'NON_RELEVANT' ? <TextField value={data.value} /> : null;
};

export default VacancyPublicationOptionField;
